<div>
  <h3 class="title-h3">CAMBIAR CONTRASEÑA</h3>

  <form [formGroup]="formPass" (ngSubmit)="savePass()">
    <div class="card-grid card-cambiar-clave">
      <div class="container-a">
        <app-form-input-text
          [label]="'Contraseña actual'"
          [type]="'password'"
          formControlName="claveOriginal"
          [messageError]="
            claveOriginal.dirty || claveOriginal.touched
              ? getErrorMessage(formPass, 'claveOriginal')
              : ''
          "
        >
        </app-form-input-text>
      </div>

      <div class="container-b">
        <app-form-input-text
          [label]="'Nueva contraseña'"
          [type]="'password'"
          formControlName="claveNueva"
          [messageError]="
            claveNueva.dirty || claveNueva.touched
              ? getErrorMessage(formPass, 'claveNueva')
              : ''
          "
        >
        </app-form-input-text>
      </div>

      <div class="container-c">
        <app-form-input-text
          [label]="'Repite nueva contraseña'"
          [type]="'password'"
          formControlName="claveNuevaReingresada"
          [messageError]="
            claveNuevaReingresada.dirty || claveNuevaReingresada.touched
              ? getErrorMessage(formPass, 'claveNuevaReingresada')
              : ''
          "
        >
        </app-form-input-text>
      </div>

      <div class="hseparator"></div>
      <div class="container-recomendacion">
        <ul>
          <li>
            Tu contraseña debe poseer entre 6 y 15 caracteres e incluir letras y
            números.
          </li>
        </ul>
      </div>
      <div class="container-d">
        <button
          type="submit"
          [disabled]="!formPass.valid || !formPass.dirty"
          mat-flat-button
          class="button-detail"
        >
          Guardar
        </button>
      </div>
    </div>
  </form>
</div>
